import { PartUploadError, PutPart, UploadCancelled } from './multipartUpload';

const retryableStatus = (status: number) => status === 0 || status === 408 || status === 429 || status >= 500;

// A raw XHR: the shared axios instance adds the portal bearer token, which would break the presigned R2 signature.
const xhrPutPart: PutPart = (url, body, onProgress, signal) =>
  new Promise<string>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const onAbort = () => xhr.abort();

    xhr.open('PUT', url);
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress(event.loaded);
      }
    };
    xhr.onload = () => {
      if (xhr.status === 403) {
        reject(new PartUploadError('The upload links expired or were rejected by R2. Upload the file again.', 403, false));
        return;
      }
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new PartUploadError(`R2 answered ${xhr.status}`, xhr.status, retryableStatus(xhr.status)));
        return;
      }

      const etag = xhr.getResponseHeader('ETag');

      if (!etag) {
        reject(new PartUploadError('R2 did not expose the ETag header; the bucket CORS rule must expose ETag', xhr.status, false));
        return;
      }

      resolve(etag);
    };
    xhr.onerror = () => reject(new PartUploadError('Network error while uploading (connection or R2 CORS)', 0, true));
    xhr.onabort = () => reject(new UploadCancelled());
    xhr.onloadend = () => signal.removeEventListener('abort', onAbort);

    if (signal.aborted) {
      reject(new UploadCancelled());
      return;
    }

    signal.addEventListener('abort', onAbort);
    xhr.send(body);
  });

export default xhrPutPart;
